import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import GamePage from './pages/GamePage';
import ChallengePage from './pages/ChallengePage';
import DownloadBanner from './components/ui/DownloadBanner';
import './App.css';

function isChallengeRoute(pathname: string): boolean {
  return pathname.startsWith('/challenge/');
}

function AppShell() {
  const { pathname } = useLocation();
  const challengeLanding = isChallengeRoute(pathname);

  return (
    <div className={`App${challengeLanding ? ' App--challenge' : ''}`}>
      {!challengeLanding && <Header />}
      <main className={`main-content${challengeLanding ? ' main-content--challenge' : ''}`}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/challenge/fs/:challengeId" element={<ChallengePage storage="firestore" />} />
          <Route path="/challenge/:challengeId" element={<ChallengePage />} />
          <Route path="/game/:gameType" element={<GamePage />} />
        </Routes>
      </main>
      {!challengeLanding && <Footer />}
      {!challengeLanding && <DownloadBanner />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;